/* eslint-disable no-unused-vars */
export enum SPECIAL_METHOD {
  BUNDLE = 'BUNDLE',
  BOGO = 'BOGO',
  PERCENT = 'PERCENT',
}
